import { render } from "./CandleFormStep5.vue?vue&type=template&id=735f1518&scoped=true&lang=html"
import script from "./CandleFormStep5.vue?vue&type=script&lang=js"
export * from "./CandleFormStep5.vue?vue&type=script&lang=js"

import "./CandleFormStep5.vue?vue&type=style&index=0&id=735f1518&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735f1518"]])

export default __exports__